export default __webpack_public_path__ + "static/media/damages.7ed975d5.png";